$(function() {
        var Accordion = function(el, multiple) {
                this.el = el || {};
                this.multiple = multiple || false;

                var links = this.el.find('.faq_title');
                links.on('click', {
                        el: this.el,
                        multiple: this.multiple
                }, this.dropdown)
        }

        Accordion.prototype.dropdown = function(e) {
                var $el = e.data.el;
                $this = $(this),
                        $next = $this.next();

                $next.slideToggle();
                $this.parent().toggleClass('open');

                if (!e.data.multiple) {
                        $el.find('.faq_content').not($next).slideUp().parent().removeClass('open');
                };
        }
        var accordion = new Accordion($('.faq_main_wrapper'), false);
});

$(document).on('click', function (event) {
    if (!$(event.target).closest('.faq_main_wrapper').length) {
    $this.parent().toggleClass('open');
  }
});
  
jQuery('.faq_main_wrapper .faq_item_wrapper').each(function(index) {
     if(index == 0) {
       jQuery( this ).addClass('open'); 
       jQuery( this ).find('.faq_content').show(); 
    }
    
    
});

jQuery( document ).ready(function($) {
 	jQuery('.image_gallery_section .logolist--inner').wrapInner('<div class="img_gallery_slider"></div>');
    
		setTimeout(function(){

		  jQuery('.img_gallery_slider').slick({
			dots: false,
			infinite: true,
			slidesToShow: 5,
			slidesToScroll: 1,
			arrows: false,
			swipe: true,
			autoplay: true,
			autoplaySpeed: 3000,
			adaptiveHeight: true,
			responsive: [
                {
                  breakpoint: 1024,
                  settings: {
                    slidesToShow: 3,
                  }
                },
                {
                  breakpoint: 768,
                  settings: {
                    slidesToShow: 2,
                  }
                },
                {
                  breakpoint: 641,
                  settings: {
                    slidesToShow: 1,
                  }
                }
                // You can unslick at a given breakpoint now by adding:
                // settings: "unslick"
                // instead of a settings object
              ]
		  });
		 

		}, 500);

    if(jQuery(window).width() < 720) {
      jQuery('.meet-designer-section .promo-grid--inner').wrapInner('<div class="mobile_designer_slider"></div>');
      jQuery( ".meet-designer-section .promo-grid--inner style" ).remove();
      jQuery('.mobile_designer_slider').slick({
			dots: true,
			infinite: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: false,
			swipe: true,
			autoplay: true,
			autoplaySpeed: 3000,
			adaptiveHeight: true,
			responsive: [
               
                {
                  breakpoint: 641,
                  settings: {
                    slidesToShow: 1,
                  }
                }
                // You can unslick at a given breakpoint now by adding:
                // settings: "unslick"
                // instead of a settings object
              ]
		  });
		 
    }
});
  

